import { Card } from "@mantine/core";
import { useOutletContext } from "react-router-dom";
import TableEmpresas from "@/modules/relatorio/components/table-empresas";
import { TRelatorioContext } from "../RelatorioLayout";

const EmpresasTab = () => {
  const { empresas, values } = useOutletContext<TRelatorioContext>();

  // Note: SelectedDate was used in VisaoGeral for AreaRelatorio,
  // but TableEmpresas also accepts it. If it needs to be shared across tabs,
  // it should be moved to the Layout state.
  // Determining if TableEmpresas needs it based on user selection in another tab is tricky.
  // For now I'm leaving it null here as cross-tab interaction wasn't explicitly requested
  // and usually filters are top-level or local.
  // Retrying checking original file... TableEmpresas uses selectedDate.
  // If the requirement is that clicking the AreaRelatorio updates the Table, then it must be in Layout.
  // I will update Layout plan to include selectedDate.

  // For now, pass null or move selectedDate to layout if critical.
  // Given the original had them on same page, likely they interacted.
  // I'll assume for now we use the context's selectedDate if I add it, or just null if isolated.
  // Let's add selectedDate to Context in Layout to be safe.

  const { selectedDate } = useOutletContext<TRelatorioContext>();

  return (
    <Card>
      <TableEmpresas empresas={empresas} questionario={values?.questionario} selectedDate={selectedDate || null} />
    </Card>
  );
};

export default EmpresasTab;
